<ul class="breadcrumb">
    <li><a [routerLink]="['/home']"><span class="color-soft-grey-axial">ESTÁS EN </span>Inicio</a></li>
    <li><i class="pi pi-angle-right"></i></li>
    <li><a [routerLink]="['/configuration/entities']">Configuración</a></li>
    <li><i class="pi pi-angle-right"></i></li>
    <li><a [routerLink]="['/configuration/provinces']">Provincias</a></li>
    <!--<li *ngIf="view"><a [routerLink]="['/configuration/provinces']">{{view.getEntityBaseName(true)}}</a></li>-->
</ul>
<p-confirmDialog [style]="{width: '50vw'}" [baseZIndex]="10000"></p-confirmDialog>
<p-card styleClass="p-card-content-fit">
    <ng-template pTemplate="header">
        <div class="p-card-title">
            IVAs
            <div class="p-card-title-actions">
                <a (click)="edit({ id: 0 })">
                    <fa-icon [icon]="['fas', 'plus-circle']"></fa-icon> Nuevo IVA
                </a>
            </div>
        </div>
    </ng-template>
    <p-table #grid [value]="taxRates" [lazy]="true" (onLazyLoad)="loadData($event)" [loading]="loading"
        [paginator]="true" [rows]="10" [totalRecords]="totalRecords" [showCurrentPageReport]="true"
        currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
        [rowsPerPageOptions]="[5,10,25,50]" paginatorDropdownAppendTo="body">
        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="id" width="100">ID</th>
                <th pSortableColumn="name">Nombre</th>
                <th pSortableColumn="percent">IVA</th>
                <th width="100"></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-taxRate>
            <tr (dblclick)="edit(taxRate)">
                <td>{{taxRate.id}}</td>
                <td>{{taxRate.name}}</td>
                <td>{{taxRate.percent}}</td>
                <td class="grid-actions">
                    <a (click)="edit(taxRate)">
                        <fa-icon [icon]="['far', 'edit']"></fa-icon>
                    </a>
                    <a (click)="delete(taxRate)" class="color-danger">
                        <fa-icon [icon]="['far', 'trash-alt']"></fa-icon>
                    </a>
                </td>
            </tr>
        </ng-template>
    </p-table>
</p-card>
